export default "__VITE_ASSET__Cw6m3$jJ__"